// extracted by mini-css-extract-plugin
module.exports = {"text":"styles_text__Z76z0","skeleton-animation":"styles_skeleton-animation__i0JT0","container":"styles_container__9reAj"};